<template>
    <div>
        <img id="photo-video-switch" :src="cameraModeAsset" alt="Camera Mode video/photo" @click="onClickChangeMode" />
    </div>
</template>

<script>
  import { sendViewerMessage } from '../webRtcViewer'

  export default {
    name: "PhotoVideoSwitchWidget",
    computed: {
      cameraModeAsset: function () {
        let cameraModeImg =  this.$store.getters.isCameraModePhoto ? "camera_mode_photo.svg" : "camera_mode_video.svg"
        return require(`../assets/${cameraModeImg}`)
      }
    },
    methods: {
      onClickChangeMode: function () {
        // invert selected camera mode based current mode
        const cameraMode = this.$store.getters.isCameraModePhoto ? 'RECORD_VIDEO' : 'SHOOT_PHOTO'

        this.$store.commit("setCameraMode", cameraMode)
        sendViewerMessage(JSON.stringify({ cameraMode: cameraMode }))
      }
    }
  }
</script>

<style scoped>

</style>
